export interface AppointmentPhaseFilterType {
  selectedPhases: server.dto.AppointmentPhase[]
}

export const getSortedPhases = (filter: AppointmentPhaseFilterType) => {
  return [...filter.selectedPhases]
    .sort((a, b) => {
      // order by option, confirmed, cancelled
      const order = ["option", "confirmed", "cancelled"];
      const indexA = order.findIndex(value => value === a.value);
      const indexB = order.findIndex(value => value === b.value);
      return indexA - indexB;
    });
};

export const initialAppointmentPhaseFilter: AppointmentPhaseFilterType = {
  selectedPhases: []
};